import _ from 'lodash';

import getIsFilterEqual from 'components/VariableFiltersSlideOut/VariableFilterCard/getIsFilterEqual';
import fiToDrillDowns from 'screens/DataManager/Metrics/MetricPopup/MetricForm/NormalMetricForm/fiToDrillDowns';

const getAreFiltersEqual = ({
  a,
  b,
  datasets,
}: {
  a: Metrics.NormalMetric;
  b: Metrics.NormalMetric;
  datasets: FleetOps.DatasetDefinition[];
}) => {
  const aFixedFilters = fiToDrillDowns(a.filters, datasets);
  const bFixedFilters = fiToDrillDowns(b.filters, datasets);

  if (aFixedFilters.length !== bFixedFilters.length) {
    return false;
  }

  const aDatasetFilters = [...(a.datasetFilterIds || [])].sort();
  const bDatasetFilters = [...(b.datasetFilterIds || [])].sort();
  if (!_.isEqual(aDatasetFilters, bDatasetFilters)) {
    return false;
  }

  return (
    aFixedFilters.every((fA) =>
      bFixedFilters.some((fB) => getIsFilterEqual(fA, fB)),
    ) &&
    bFixedFilters.every((fB) =>
      aFixedFilters.some((fA) => getIsFilterEqual(fA, fB)),
    )
  );
};

/**
 * Two normal metrics are duplicates if they aggregate the same field of the
 * same dataset in the same way, under the same filters (order-insensitive).
 *
 * Name, description, formatting and status are not considered.
 *
 * `datasets` is only used to resolve field types for exists / not-exists
 * filters.
 */
const getIsNormalMetricDuplicate = ({
  a,
  b,
  datasets,
}: {
  a: Metrics.NormalMetric;
  b: Metrics.NormalMetric;
  datasets: FleetOps.DatasetDefinition[];
}): boolean => {
  const isBaseEqual =
    a.dataType === b.dataType && a.aggFunc === b.aggFunc && a.field === b.field;

  return isBaseEqual && getAreFiltersEqual({ a, b, datasets });
};

export default getIsNormalMetricDuplicate;
